import React, { useState } from "react";
import styled from "@emotion/styled";
import DiscountCard from "@components/DiscountCard";
import {
  getMerchantArray,
  getCategoryMerchantArray
} from "@modules/Buy/selector";
import { useSelector } from "react-redux";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 20px;
  grid-row-gap: 82px;
  margin-top: 67px;
  @media (max-width: 1300px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 925px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 575px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 450px) {
    margin-top: 73px;
  }
`;

const LoadMoreButton = styled.div`
  border-radius: 10px;
  height: 60px;
  padding-right: 50px;
  padding-left: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #12b2ea;
  background-color: rgba(18, 178, 234, 0.1);
  width: fit-content;
  font-weight: bold;
  width: fit-content;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 50px;
  font-size: 20px;
`;

const CardRow = () => {
  const allDiscountedMerchants = useSelector(state =>
    !state.userActions.selectedCategory
      ? getMerchantArray({
          merchantArray: state.merchantsBuy.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards
        })
      : getCategoryMerchantArray({
          merchantArray: state.merchantsBuy.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards,
          categories: state.categories.allCategories,
          categoryName: state.userActions.selectedCategory
        })
  );
  const currentSearch = useSelector(state => state.userActions.buySearchText);

  const [loadingStage, setLoadingStage] = useState(0);
  const [slicer, setSlicer] = useState(28);

  return (
    <>
      <GridContainer className="animated fadeIn">
        {allDiscountedMerchants
          .slice(0, currentSearch?.length > 0 ? 3000 : slicer)
          .map(card => (
            <DiscountCard
              key={card.id}
              moveToMerchantDetail={card.slug}
              name={card.name}
              cardsAvailable={card.cardsAvailable}
              upToPercentage={card.upToPercentage}
              img={card.image}
            />
          ))}
      </GridContainer>
      {allDiscountedMerchants.length > slicer &&
        loadingStage < 2 &&
        currentSearch.length < 1 && (
          <LoadMoreButton
            onClick={() => {
              setSlicer(loadingStage === 0 ? 128 : 3000);
              setLoadingStage(loadingStage + 1);
            }}
          >
            {loadingStage === 0 ? "Load more" : "Load all"}
          </LoadMoreButton>
        )}
    </>
  );
};

export default CardRow;
